import { BUTTON_PRESS } from '@/utils/analytics'

// redux-persist writes the opt-in to localStorage but does not sync it between
// tabs, so a peer tab keeps stale state — and keeps raising banners — until it
// reloads. Changes are broadcast on this channel instead.
export const BROWSER_NOTIFICATION_SETTINGS_CHANNEL =
  'BROWSER_NOTIFICATION_SETTINGS_CHANNEL'

// Only the test banner auto-closes. Incident banners deliberately persist, so
// an operator back at their desk finds a queue of what they missed.
export const TEST_BANNER_AUTO_CLOSE_MS = 20_000

/**
 * How much Incident detail a banner carries. Flip to `false` for
 * "A new Incident requires your attention" with no identifying detail.
 *
 * Banners are readable on a lock screen and persist in the notification
 * centre, so detail is a real disclosure on a shared workstation. Not a user
 * setting — it's a deployment-wide privacy posture.
 */
export const shouldShowIncidentDetail = true

export const BROWSER_NOTIFICATION_ANALYTICS = {
  bannerClicked: 'Clicked Incident Browser Notification',
  permissionResult: 'Browser Notification Permission Result',
  testBanner: `${BUTTON_PRESS} Settings - Browser Notifications - Test Notification`,
  toggleEnabled: `${BUTTON_PRESS} Settings - Browser Notifications - Toggle`,
} as const

// Prefix only — each test banner appends a counter. A reused tag replaces its
// predecessor without re-alerting, which made the button look broken.
export const TEST_BANNER_TAG_PREFIX = 'hivewatch-test-notification'

// Mid-tone fill on purpose: the OS picks the notification background from the
// system appearance, so a white glyph vanishes on light and a navy one on dark.
export const BANNER_ICON = '/Icon-Blue.svg'

export const SENTRY_TAGS = {
  feature: 'browser_notifications',
  surface: 'incident_notifications',
}
